<form [formGroup]="form">
    <mat-accordion class="w-100">
        <mat-expansion-panel>
        <mat-expansion-panel-header>
            <mat-panel-title>
            <b>Generali</b>
            </mat-panel-title>
        </mat-expansion-panel-header>
        <p>
            <mat-form-field class="form-fields-wrapper">
                <mat-label>Email</mat-label>
                <input matInput placeholder="Username" formControlName="username">
                <mat-icon matSuffix>account_circle</mat-icon>
            </mat-form-field>
            
            <mat-form-field class="form-fields-wrapper">
                <mat-label>Password</mat-label>
                <input matInput placeholder="Password" formControlName="password" type="password">
                <mat-icon matSuffix>lock</mat-icon>
            </mat-form-field>

            <mat-form-field class="form-fields-wrapper">
            <mat-label>Client ID</mat-label>
            <input matInput placeholder="Client ID" formControlName="client_id">
            <!--<mat-icon matSuffix>account_circle</mat-icon>-->
            </mat-form-field>

            <mat-form-field class="form-fields-wrapper">
                <mat-label>URL</mat-label>
                <input matInput  formControlName="url">
            </mat-form-field>

            <mat-form-field class="form-fields-wrapper">
                <mat-label>Auth client ID</mat-label>
                <input matInput formControlName="auth_client_id">
            </mat-form-field>

            <mat-form-field class="form-fields-wrapper">
                <mat-label>Auth client secret</mat-label>
                <input matInput formControlName="auth_client_secret" type="password">
            </mat-form-field>
        </p>
        <div>
            <div class="mat-form-field margin-bottom">
                <mat-slide-toggle formControlName="enabled" color="primary">Abilitato</mat-slide-toggle>
            </div>
        </div>
        <div class="col">
            <button mat-raised-button color="primary" class="mb-2" (click)="Salva()">
                Salva
            </button>
        </div>
        </mat-expansion-panel>
    </mat-accordion>
</form>
